import React, { type ReactElement } from 'react';
import range from 'lodash/range';
import StarIcon from '@atlaskit/icon/glyph/star';
import StarFilledIcon from '@atlaskit/icon/glyph/star-filled';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

const getStars = (rating: number, scale = 5): ReactElement => {
	const stars = range(scale).map((starIndex) =>
		starIndex < rating ? (
			<StarFilledIcon
				testId="servicedesk-reports-common.ui.table.issue-table.body.field-renderer.fields.ratings.star-filled-icon"
				key={starIndex}
				primaryColor={token('color.icon.accent.orange', colors.Y300)}
				label={`${starIndex} star filled`}
			/>
		) : (
			<StarIcon
				testId="servicedesk-reports-common.ui.table.issue-table.body.field-renderer.fields.ratings.star-icon"
				key={starIndex}
				primaryColor={token('color.icon', colors.N60)}
				label={`${starIndex} star unfilled`}
			/>
		),
	);

	return <>{stars}</>;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Ratings = range(6).map<any>((id: number) => getStars(id));

export default Ratings;
